import { useQuery } from "@apollo/client";

import React, { useMemo, useState, useEffect, useCallback } from "react";

import SubscriptionBlock from "../../components/SubscriptionBlock/SubscriptionBlock";
import { CARD_TEMPLATES, CARD_TEMPLATES_GROUP } from "../../../../../graphql/queries/queriesCard";

function SubscriptionSection() {
  const { data: { cardTemplates: allCardTemplates = [] } = {} } = useQuery(CARD_TEMPLATES, {
    onCompleted: ({ cardTemplates = [] }) => {
      const cards = [...cardTemplates];
      return cards.sort((a, b) => a.order - b.order);
    },
  });

  // Все Группы для выбора абониментов (по которым есть карточки)
  const { data: { cardTemplateGroups: allCardTemplateGroups = [] } = {} } = useQuery(CARD_TEMPLATES_GROUP, {
    onCompleted: ({ cardTemplateGroups = [] }) => {
      const cardByGroups = [...cardTemplateGroups];
      return cardByGroups.sort((a, b) => a.order - b.order);
    },
  });

  // ID выбраной категории абонемента
  const [activeTemplateGroupeId, setActiveTemplateGroupeId] = useState(null);

  const changeActiveId = useCallback((id) => {
    setActiveTemplateGroupeId(id);
  }, []);

  const allGroupsForReturn = useMemo(() => {
    if (!allCardTemplateGroups?.length || !allCardTemplates?.length) return [];

    // Оставляем только те группы, в которых есть соответствующие карточки
    return allCardTemplateGroups.filter((group) => allCardTemplates.some(({ group: cardGroup }) => cardGroup?.id === group.id));
  }, [allCardTemplateGroups, allCardTemplates]);

  const allCardsForReturn = useMemo(() => {
    if (!allCardTemplates?.length) return [];

    // Если категория не выбрана, возвращаем все карточки
    if (!activeTemplateGroupeId || activeTemplateGroupeId === -1) return allCardTemplates;

    return allCardTemplates.filter(({ group: cardGroup }) => cardGroup?.id === activeTemplateGroupeId);
  }, [allCardTemplates, activeTemplateGroupeId]);

  // (поумолчанию ID выбраной категории абонемета устанавливается по меньшему order)
  useEffect(() => {
    if (activeTemplateGroupeId || !allGroupsForReturn.length) return;

    const mainGroup = allGroupsForReturn.reduce((prev, curr) => (curr.order < prev.order ? curr : prev), allGroupsForReturn[0]);
    setActiveTemplateGroupeId(mainGroup?.id || null);
  }, [allGroupsForReturn, activeTemplateGroupeId]);

  // Не вывожу блок если пустое поле выбора абонементов или нет абонементов впринципе
  const isShowBlock = useMemo(() => {
    return allCardTemplates?.length && allGroupsForReturn?.length;
  }, [allCardTemplates, allGroupsForReturn]);

  return (
    <>
      {isShowBlock && (
        <section className="subscription-section main-padding-block club-page--background">
          <SubscriptionBlock
            allGroupsForReturn={allGroupsForReturn}
            activeTemplateGroupeId={activeTemplateGroupeId}
            allCardTemplates={allCardsForReturn}
            changeActiveId={changeActiveId}
            cardOpenPriceEnabled
          />
        </section>
      )}
      <style jsx global>{`
        @import "./SubscriptionSection.scss?";
        @import "../ClientSubscriptions/ClientSubscriptions.scss?1";
      `}</style>
    </>
  );
}

export default SubscriptionSection;
